import { addDeleteGetLocalStorage, storageKeys } from "../global/localData";
import { jwtDecode } from "jwt-decode";
import { selectTime } from "./constants";
import jsPDF from "jspdf";
import { saveAs } from "file-saver";
import { format, toZonedTime } from 'date-fns-tz';

/**
 * decode encode jwt token
 */
export const jwt_decode = (value) => {
  return value ? jwtDecode(value) : {};
};

/**
 * check login or not
 */
export const getToken = async () => {
  let token = addDeleteGetLocalStorage(storageKeys?.USER_TOKEN, {}, "get");
  return token;
};

/**
 * get default language
 */
export const getDefaultLanguage = (type = "small") => {
  let ldata = localStorage.getItem("jsahdjkanbn");
  ldata = ldata === "sd5s42s3ad2sa1d3iu748923DSF" ? "AR" : "EN";
  if (type !== "small") {
    return ldata;
  }
  return ldata.toLowerCase();
};

/**
 * clear local storage data
 */
export const clearLocalData = () => {
  localStorage.clear();
};

/**
 * redirect page
 */
export const redirectPage = (page) => {
  window.location.href = page ? page : "/";
};

//format date
export const formatDateFunction = (inputDate, format = "dd/mm/yyyy", time = false, at = "") => {
  if (!inputDate) return inputDate;

  const date = new Date( new Date(inputDate).toLocaleString("en-US", { timeZone: "Asia/Riyadh" }) );

  const day = date.getDate().toString().padStart(2, "0");
  const month = (date.getMonth() + 1).toString().padStart(2, "0");
  const year = date.getFullYear();
  let timeOfDate = ``;
  if (time) {
    let hours = date.getHours();
    const amOrPm = hours >= 12 ? "PM" : "AM";
    hours = hours % 12 || 12; // Convert to 12-hour format
    const minutes = date.getMinutes().toString().padStart(2, "0");
    timeOfDate = `${hours}:${minutes} ${amOrPm}`;
    if (at !== "") timeOfDate = ` ${at} ${timeOfDate}`;
  }

  if (format === "dd/mm/yyyy") {
    if (time) return `${day}/${month}/${year} ${timeOfDate}`;
    return `${day}/${month}/${year}`;
  } else if (format === "yyyy-mm-dd") {
    if (time) return `${year}-${month}-${day} ${timeOfDate}`;
    return `${year}-${month}-${day}`;
  } else if (format === "mm/dd/yyyy") {
    if (time) return `${month}/${day}/${year} ${timeOfDate}`;
    return `${month}/${day}/${year}`;
  } else if (format === "dd-mm-yyyy") {
    if (time) return `${day}-${month}-${year} ${timeOfDate}`;
    return `${day}-${month}-${year}`;
  }
};

//format date
export const formatDateFunctionNew = (inputDate) => {
  if (!inputDate) return inputDate;
  const date = new Date(inputDate);

  // Format the date to 'Wed, 3 Jul 2024'
  return new Intl.DateTimeFormat("en-US", {
    weekday: "short",
    year: "numeric",
    month: "short",
    day: "numeric",
  }).format(date);
};

export const convertValueToLable = (value) => {
  let lable = "";
  for (let item of selectTime) {
    if (item.value === value) lable = item.label;
  }
  return lable;
};

export const capitalizeName = (name) => {
  if (!name) return name;
  return name
    .split(" ")
    .map((word) => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase())
    .join(" ");
};

export const convertSlote = (slote) => {
  if (!slote) return "";

  let [hour, minute] = slote.split(":").map(Number); // Split the time and convert to numbers
  const period = hour >= 12 ? "PM" : "AM"; // Determine AM or PM
  hour = hour % 12 || 12; // Convert 24-hour format to 12-hour format
  const formattedMinute = minute.toString().padStart(2, "0"); // Ensure minutes are two digits
  return `${hour}:${formattedMinute} ${period}`; // Return the formatted time
};

export const changeDateFormate = (date) => {
  if (date) {
    const [year, month, day] = date.split("-");
    return `${day}/${month}/${year}`;
  }
};

const isAdmin = () => {
  const userAccess = addDeleteGetLocalStorage(storageKeys?.USER_TOKEN, {}, "get");
  if (userAccess) {
    const decoded = jwtDecode(userAccess);
    return decoded?.user?.roleId === 1;
  }
  return false;
};

export const checkPermission = (moduleName = [], permissionJson = []) => {
  if (isAdmin()) return true;
  if (moduleName.length > 0) {
    let token = false;
    for (let module of moduleName) {
      for (let permission of permissionJson) {
        if (permission?.view === 1 && module === permission?.moduleName) token = true;
      }
    }
    return token;
  } else return false;
};

export const checkPermissionAction = (moduleName = "", permissionJson = [], action = "") => {
  if (isAdmin()) return true;
  if (moduleName !== "") {
    let token = false;
    for (let permission of permissionJson) {
      if (moduleName === permission?.moduleName && permission[action] === 1) {
        token = true;
        break;
      }
    }
    return token;
  } else return false;
};

export const exportPDf = (headers, rows, name) => {
  //Create a new PDF instance
  const doc = new jsPDF();
  // Add title
  doc.text("Orders Report", 10, 10);
  // Add the table to the PDF
  doc.autoTable({
    head: [headers],
    body: rows,
  });
  // Save the PDF
  doc.save(name);
};

export const exportCSV = (exportData, name) => {
  const headers = Object.keys(exportData[0]).join(","); // Extract headers
  const rows = exportData.map((row) =>
    Object.values(row)
      .map((value) => `"${value}"`) // Escape values
      .join(",")
  );
  const csvContent = [headers, ...rows].join("\n");

  // Create a Blob and save file
  const blob = new Blob([csvContent], { type: "text/csv;charset=utf-8;" });
  saveAs(blob, name);
};

export const roundToDecimal = (num, decimalPlaces) => {
  if (num === null || num === undefined) {
    return null; // or handle the case as needed
  }
  if (isNaN(num)) {
    return num; // or handle the case as needed
  }

  const factor = Math.pow(10, decimalPlaces);
  return Math.round(num * factor) / factor;
};

function formatInTimeZone(date, timeZone, formatStr, options = {}) {
  const zonedDate = toZonedTime(date, timeZone, options);
  return format(zonedDate, formatStr, { timeZone, ...options });
}

export const convertDateString = (inputDate = '', formatStr = 'dd/MM/yyyy') => {
  try {
    if (!inputDate) return '-';
    const date = new Date(inputDate);

    if (isNaN(date)) {
      console.warn('Invalid date:', inputDate);
      return '-';
    }

    const timeZone = 'Asia/Riyadh';
    const formattedDate = formatInTimeZone(date, timeZone, formatStr);
    return formattedDate;
  } catch (error) {
    return 'error';
  }
};


export function removeHtmlFromString(html) {
    return html ? html.replace(/<[^>]*>|&nbsp;/g, '') : '';
}

export const isEditPermissionm = (data, moduleName, type, isId) => {
    let token = addDeleteGetLocalStorage(storageKeys?.USER_TOKEN, {}, 'get');
    if (!token) {
        return false;
    }

    let tokenData = token ? jwtDecode(token) : {};

    if (tokenData?.user?.userRole === 'admin') {
        return true;
    }

    if (!data) {
        const permissionArray = tokenData?.user?.rolePermission?.permissionJson || [];
        console.log("Permission Array:", permissionArray);
        data = {};
        permissionArray.forEach((item) => {
            data[item.moduleName] = {
                edit: Boolean(item.edit),
                create: Boolean(item.add),      // ✅ `add` → `create`
                delete: Boolean(item.delete),
                view: Boolean(item.view),
            };
        });
        console.log("Constructed Data Object:", data);
    }

    if (type === 'edit-create') {
        type = isId ? 'edit' : 'create';
    }

    // console.log("Checking model:", moduleName);
    // console.log("Checking type:", type);
    console.log("Final permission value:", data?.[moduleName]?.[type]);

    return data?.[moduleName]?.[type] || false;
};





/**
 * webDateFormate
 */
export const getdataByKey = (array, lang, key) => {
  const item = array?.find(i => i.languagecode === lang);
  return item ? item[key] : "";
};

// amount validation with decimal places
export const amountValidation = () => [
  {
    required: true,
    message: "Please enter your amount.",
  },
  {
    validator: (_, value) =>
      !value || /^\d+(\.\d{1,2})?$/.test(value)
        ? Promise.resolve()
        : Promise.reject(
            new Error("Only numeric values (up to 2 decimal places) are allowed.")
          ),
  },
];

export const getMapLink = (latLng) => {
  if (!latLng || latLng === "N/A" || latLng === "-") return null;

  const [lat, lng] = latLng.split("-");
  if (!lat || !lng) return null;

  return `https://www.google.com/maps?q=${lat},${lng}`;
};

export const getTabFromOrderStatus = (status) => {
  switch (status) {
    case "initiated":
    case "approved":
      return "1";

    case "preparing":
      return "2";

    case "in_review":
      return "3";

    case "ready_to_ship":
      return "4";

    case "shipped":
      return "5";

    case "ready_to_pickup":
      return "6";

    case "completed":
    case "delivered":
      return "9";

    case "cancelled":
      return "8";

    case "no_show":
      return "7";

    default:
      return "1";
  }
};

export const formatText = (text = "") => {
  if (!text) return "N/A";
  return text.replace(/_/g, " ").replace(/\b\w/g, c => c.toUpperCase());
};

export const organizeDataByMonthAndYear = (data, key) => {
    const organizedData = {};

    data.forEach((transaction) => {
        const createdAt = new Date(transaction[key]);
        const monthYearKey = `${createdAt.toLocaleString("default", {
            month: "long",
        })} ${createdAt.getFullYear()}`;
        if (!organizedData[monthYearKey]) {
            organizedData[monthYearKey] = [];
        }
        organizedData[monthYearKey].push(transaction);
    });
    const result = Object.keys(organizedData).map((key) => ({
        [key]: organizedData[key],
    }));

    return result;
};
